module.exports = __webpack_public_path__ + "public/img/study_yjk1.92dab55d.png";